<template>
  <div>
    <BaseLoader :loading="loading"/>
    <div>
      <p>
        <input class="form-control"
               type="text"
               @input="debounceInput"
               placeholder="Filter...">
        <small v-if="filterText.length > 0 && filterText.length < 4" class="form-text text-muted">
          Write more than 3 characters to filter by name
        </small>

      </p>

      <ul ref="fetchList" class="fetch-list" v-if="collection">
        <slot v-for="(item) in collection" :item="item"></slot>
        <li v-if="loadingNextPage">Loading...</li>
      </ul>
    </div>

  </div>

</template>

<script>
    import { EventBus } from '../lib/event-bus.js';
    import { HTTP } from '../lib/http';

    export default {
        name: "FetchList",
        props: {
            url: String,
        },
        components: {
            HTTP,
            EventBus,
        },
        data() {
            return {
                collection: [],
                filterText: '',
                counter: 0,
                loadingNextPage: false,
                loading: true,
                firstPage: null,
                nextPage: null,
                prevPage: null,

            };
        },
        computed: {
            params() {
                let query = {
                    sort: { name: 'ASC' },
                    pagination: { number: 1, size: 25 }
                };
                if (this.filterText.length > 2) {
                   query['filter'] = { name: this.filterText }
                }

                return query;
            },
            urlWithParams() {
              return `${this.url}${this.getQueryParams(this.params)}`
            }
        },
        watch: {
            urlWithParams(newVal, oldVal) {
                this.fetch({replace: true});
            }
        },
        methods: {
            debounceInput: _.debounce(function (e) {
                this.filterText = e.target.value
            }, 1000),
            request(options = {}) {
                return HTTP.get(options.url)
                    .then(response => {
                        if (options.replace) {
                            this.collection = response.data.data;
                        } else {
                            this.collection = this.collection.concat(response.data.data);
                        }
                        this.firstPage = response.data.links.first;
                        this.nextPage = response.data.links.next;
                        this.prevPage = response.data.links.prev;
                    })
                    .catch(err => {
                        this.errors = [err.response.data.errors];
                    })
            },
            fetch(options = {}) {
                this.loading = true;
                options.url = this.urlWithParams;
                this.request(options)
                  .then(()=> {
                        this.loading = false;
                        this.initEventListener();
                    });
            },
            fetchNext() {
                if (this.nextPage) {
                    this.loadingNextPage = true;
                    this.request({ url: this.nextPage })
                        .then(() => {
                            this.initEventListener();
                            this.loadingNextPage = false;
                        });
                }
            },
            initEventListener() {
                let handler = ()=> {
                    let pos = _(this.$refs.fetchList.children).last().getBoundingClientRect();
                    let scrollTop = this.$refs.fetchList.scrollTop;

                    if (pos.y < (scrollTop)) {
                        this.$refs.fetchList.removeEventListener('scroll', handler, false);
                        this.counter++;
                        this.fetchNext()
                    }
                };

                this.$refs.fetchList.addEventListener('scroll', handler, false)
            },

        },

        beforeMount() {
        },
        mounted () {
            this.fetch()
        }

    };
</script>

<style scoped lang="scss">
  @import "../../src/assets/scss/variablesx";

  .ingredients {
    .no-match,
    ul {
      height: 250px;
    }
    ul {
      overflow: scroll;
      list-style-type: none;
      padding: 0;
      margin-left: -15px;
      margin-right: -15px;

      li {
        position: relative;
        border-top: 1px solid $gray-200;
        padding: 10px;
        cursor: pointer;

        &:hover {
          background: $gray-200;
        }

        &.selected {
          background: $gray-600;
          color: $white;

          & > div.name span.producer {
            color: $white;
          }
        }

        &.header {
          border: 0;
          font-weight: bold;
          padding-bottom: 0;
          font-size: .8em;

          &:hover {
            background: 0;
            cursor: default;
          }
        }
      }
    }
  }
</style>
